import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../component/img/logo3.jpg";
import { Menu, ChevronDown, Headphones, PhoneCall, User, Monitor, Send, DollarSign } from "react-feather";
import profileAvatar from "../component/img/avatar.png";
import { useNavigate } from "react-router-dom";

const AgentNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const toggleProfileDropdown = () => setIsProfileDropdownOpen(!isProfileDropdownOpen);


  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("agent_id");
    localStorage.removeItem("agent_email");
    console.log("User logged out.");
    navigate("/login");
  };



  return (
    <>
      <section className="sticky-top hedshdw">
        <nav className="navbar-expand-lg bg-white agentnavbar">
          <div className="container d-flex">
            <Link className="navbar-brand text-white">
              <img src={logo} className="img-fluid logo" alt="Logo" />
            </Link>
            <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <div className="py-2">
                  <span className="me-4">
                    <Link to="/agent-dashboard">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Dashboard</span>
                    </Link>
                  </span>
                  <span className="me-4">
                    <Link to="/flight-booking" className="menuagent">
                      <span>
                        <Send size={18} />{" "}
                      </span>
                      <span className="menuagent">Flights</span>
                    </Link>
                  </span>
                  <span className="me-4">
                    <Link to="/hotel-booking" className="menuagent">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Hotel</span>
                    </Link>
                  </span>
                  <span className="me-4">
                    <Link to="/bus-booking">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Bus</span>
                    </Link>
                  </span>
                  <span className="me-4">
                    <Link to="/booking-report">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Reports</span>
                    </Link>
                  </span>
                  <span className="me-4">
                    <Link to="/agent/recharge">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Recharge</span>
                    </Link>
                  </span>
                  <span className="me-4">
                    <Link to="/add-markup">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Add Markup</span>
                    </Link>
                  </span>

                  <span className="me-4">
                    <Link to="/agent/my-wallet">
                      <span>
                        <DollarSign size={18} />{" "}
                      </span>
                      <span className="menuagent">My Wallet</span>
                    </Link>
                  </span>


                  <span className="me-4">
                    <Link to="/agent/my-pins">
                      <span>
                        <DollarSign size={18} />{" "}
                      </span>
                      <span className="menuagent">My Pins</span>
                    </Link>
                  </span>



                  

                </div>
                <li className="nav-item dropdown">
                  <span
                    onClick={toggleProfileDropdown}
                    role="button"
                    className="d-flex align-items-center profile-dropdown"
                  >
                    <img
                      src={profileAvatar}
                      alt="Profile Avatar"
                      className="rounded-circle"
                      style={{ width: "40px", height: "40px" }}
                    />
                    <ChevronDown
                      className="ms-2"
                      aria-expanded={isProfileDropdownOpen ? "true" : "false"}
                    />
                  </span>
                  {isProfileDropdownOpen && (
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <Link className="dropdown-item" to="/my-profile">
                          My Account
                        </Link>
                      </li>
                      <li>
                        <span className="dropdown-item" onClick={handleLogout}>
                          Logout
                        </span>
                      </li>
                    </ul>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="bg-white"></div>
      </section>
    </>
  );
};

export default AgentNavbar;
